exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".base-color-feature-color-container-1q7l1{width:auto;height:1px;margin:-7px 5px 0;align-self:center;border:1px solid rgba(0,0,0,.24)}.base-color-feature-color-container-double-3lkNc{width:14px;height:1px;background-color:#ffb84d;position:absolute;bottom:2px;margin:0 5px}", ""]);

// Exports
exports.locals = {
	"color-container": "base-color-feature-color-container-1q7l1",
	"color-container-double": "base-color-feature-color-container-double-3lkNc"
};